const Footer = () => {
  return (
    <div
      className="flex justify-center py-10"
      style={{
        backgroundColor: '#1c2039'
      }}
    >
      <div
        className="space-y-5"
        style={{
          width: '1199px'
        }}
      >
        <div
          className="w-full grid grid-cols-3 text-white"
        >
          <div className="space-y-2">
            <div 
              className="font-bold"
              style={{
                fontSize: '15px'
              }}
            >
              Tentang
            </div>
            <div
              className="grid grid-cols-2 gap-3 w-1/2"
              style={{
                fontSize: '13px'
              }}
            >
              <label>Tentang kami</label>
              <label>Kontak kami</label>
              <label>Bantuan</label>
              <label>Karir</label>
            </div>
          </div>
          <div className="space-y-2">
            <div 
              className="font-bold"
              style={{
                fontSize: '15px'
              }}
            >
              Lainnya
            </div>
            <div
              className="grid grid-cols-1 gap-3 w-3/4"
              style={{
                fontSize: '13px'
              }}
            >
              <label>Syarat dan ketentuan</label>
              <label>Kebijakan Privasi</label>
            </div>
          </div>
          <div>
            <div className="font-bold">Ikuti kami</div>
          </div>
        </div>
        <div
          className="text-white pt-10"
          style={{
            fontSize: '13px'
          }}
        >
          Jl. Amil Raya No. 60 Pejaten Barat - Pasar Minggu, 12510, Indonesia.
        </div>
      </div>

    </div>
  )
}

export default Footer;